module.exports = __webpack_public_path__ + "img/12217_4.b38170c9.png";